import React from 'react';

import DecentText from '~/components/patterns/typography/DecentText';

import {
	useUserAgentsQuery,
} from './UserAgentHeaderValue.gql';

import {
	UserAgent,
} from '~/model/websites/userAgents';

import useWebsiteId from '~/hooks/useWebsiteId';

import {
	UserAgentFieldsScope
} from '~/components/app/UserAgentFields';



function usePrefetch() {
	const websiteId = useWebsiteId();
	return useUserAgentsQuery({ variables: { websiteId } });
}


type Props = {
	userAgent?: UserAgent | null,
	customHeaderValue?: string | null,
	isUserAgentBranded: boolean,
	userAgentOptions?: ReadonlyArray<{
		readonly headerValue: string,
		readonly isBranded: boolean,
		readonly type: string,
	}> | null,
	scope: UserAgentFieldsScope,
};

const UserAgentHeaderValue: React.FC<Props> = (props) => {
	const {
		customHeaderValue = null,
		userAgent: userAgentType = null,
		isUserAgentBranded,
		userAgentOptions,
		scope,
	} = props;

	const websiteId = useWebsiteId();
	const fetchUserAgentParams = scope === UserAgentFieldsScope.Website ? { variables: { websiteId } } : undefined;
	const { data } = useUserAgentsQuery(fetchUserAgentParams);

	if (userAgentType === UserAgent.Custom) {
		return (
			<DecentText>
				{customHeaderValue}
			</DecentText>
		);
	}

	const userAgent = userAgentOptions?.find((agent) => agent.type === userAgentType)
		|| data?.userAgents.find((agent) => agent.type === userAgentType);

	if (!userAgent) {
		return null;
	}

	const baseHeaderValue = userAgent.headerValue;

	let headerValue = baseHeaderValue;

	if (userAgentType !== UserAgent.ContentKing
		&& userAgentType !== UserAgent.Conductor
	) {
		if (!isUserAgentBranded) {
			headerValue = baseHeaderValue
				.replace(/;\s*\+https:\/\/whatis\.contentkingapp\.com\)/, ')')
				.replace(/\s*\(\+https:\/\/whatis\.contentkingapp\.com\)/, '')
				.replace(/;\s*\+https:\/\/whatis\.conductor\.com\)/, ')')
				.replace(/\s*\(\+https:\/\/whatis\.conductor\.com\)/, '');
		}
	}

	return (
		<DecentText>
			{headerValue}
		</DecentText>
	);
};



export default UserAgentHeaderValue;

export {
	usePrefetch,
};
